<template>
  <div class="space-y-6">
    <div class="grid grid-cols-1 gap-6">
      <div class="space-y-2">
        <label class="text-sm font-medium text-foreground"
          >Certification*</label
        >
        <input
          :value="item.certification"
          @input="update('certification', $event.target.value)"
          type="text"
          placeholder="e.g. Fundamentals of Frontend Development"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>

      <div class="space-y-2">
        <label class="text-sm font-medium text-foreground">Issued by*</label>
        <input
          :value="item.issued_by"
          @input="update('issued_by', $event.target.value)"
          type="text"
          placeholder="e.g. Udemy"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>

      <div class="space-y-2">
        <label class="text-sm font-medium text-foreground">Year issued*</label>
        <input
          :value="item.year_issued"
          @input="update('year_issued', $event.target.value)"
          type="text"
          placeholder="e.g. 2024"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificatesForm",
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        certification: "",
        issued_by: "",
        year_issued: "",
      }),
    },
  },
  emits: ["update"],
  methods: {
    update(key, value) {
      this.$emit("update", { [key]: value });
    },
  },
};
</script>
